import { useState } from 'react';
import { useTranslation, Button } from '@packages/utils';
import { useTheme } from 'styled-components';
import { Col } from 'components/Base/Grid';
import { EIconNames, Icon } from 'components/Base/Icon';
import { TEventFamilyListActionsProps } from './EventFamilyListActions.types';
import EditEventFamilyModal from './EditEventFamilyModal';

const eventFamilyListKey = 'descriptions.admin-portal.family.event-family-list';

const EventFamilyListActions = ({
  familyData,
}: TEventFamilyListActionsProps) => {
  const theme = useTheme();
  const { t } = useTranslation({
    keyPrefix: eventFamilyListKey.concat('.actions.edit-family'),
  });
  const [openEditModal, setOpenEditModal] = useState<boolean>(false);

  return (
    <>
      <Col>
        <Button
          icon={
            <Icon
              icon={EIconNames.EDIT_FILLED}
              size={14}
              className="pointer"
              color={theme.colorPrimaryDefault}
            />
          }
          tooltip={t('EDIT_FAMILY_BTN_TOOLTIP', 'Edit')}
          onClick={() => setOpenEditModal(true)}
          color="primary"
          shape="circle"
          size="middle"
        />
      </Col>

      {openEditModal && familyData && (
        <EditEventFamilyModal
          open={openEditModal}
          setOpen={setOpenEditModal}
          familyData={familyData}
        />
      )}
    </>
  );
};

export default EventFamilyListActions;
